/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** Identity provider that verifies community membership. */
export type CommunityVerificationProvider = 'IDME';

/** Whether a verified group membership is still within its verification window. */
export type VerifiedGroupStatus = 'ACTIVE' | 'EXPIRED';

export type VerifyGroupInput = {
  /** Authorization code returned by the provider. */
  readonly code: string;
  /** PKCE verifier the client used to build the code challenge. */
  readonly codeVerifier: string;
  readonly provider: CommunityVerificationProvider;
  /** Redirect URI used for the authorize request. Must be allow-listed server side. */
  readonly redirectUri: string;
};

export type VerifyGroupMutationVariables = Exact<{
  input: Types.VerifyGroupInput;
}>;

export type VerifyGroupMutation = {
  readonly verifyGroup:
    | {
        readonly __typename: 'CommunityIdentityLinkedToAnotherAccount';
        readonly errorMessage: string;
      }
    | { readonly __typename: 'CommunityVerificationNotVerified'; readonly errorMessage: string }
    | {
        readonly __typename: 'CustomerLinkedToDifferentCommunityIdentity';
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'VerifyGroupSuccess';
        readonly verifiedGroups: ReadonlyArray<{
          readonly provider: Types.CommunityVerificationProvider;
          readonly group: string;
          readonly status: Types.VerifiedGroupStatus;
          readonly verifiedAt: string;
          readonly expiresAt: string;
        }>;
      };
};

export const VerifyGroupDocument = gql`
  mutation VerifyGroup($input: VerifyGroupInput!) {
    verifyGroup(input: $input) {
      __typename
      ... on VerifyGroupSuccess {
        verifiedGroups {
          provider
          group
          status
          verifiedAt
          expiresAt
        }
      }
      ... on CommunityIdentityLinkedToAnotherAccount {
        errorMessage
      }
      ... on CustomerLinkedToDifferentCommunityIdentity {
        errorMessage
      }
      ... on CommunityVerificationNotVerified {
        errorMessage
      }
    }
  }
`;

export function useVerifyGroupMutation() {
  return Urql.useMutation<VerifyGroupMutation, VerifyGroupMutationVariables>(VerifyGroupDocument);
}
